import { userServerAddress } from "./MetaSetting";

/**
 * 获取头像URL
 * @param avatarPath 头像路径
 * @returns 完整的头像URL或默认头像路径
 */
export const getAvatarUrl = (avatarPath?: string): string => {
  if (!avatarPath) {
    return "/default_user.png";
  }

  // 如果avatarPath已经是完整URL，直接使用
  if (avatarPath.startsWith("http")) {
    return avatarPath;
  }

  // 否则拼接完整URL
  return `${userServerAddress}${avatarPath}`;
};
